import { render, staticRenderFns } from "./ListagemOperacaoPendenteTransacao.vue?vue&type=template&id=5b6abe2e&scoped=true"
import script from "./ListagemOperacaoPendenteTransacao.vue?vue&type=script&lang=js"
export * from "./ListagemOperacaoPendenteTransacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6abe2e",
  null
  
)

export default component.exports